import { render } from "./Main.vue?vue&type=template&id=43baa6b4&scoped=true"
const script = {}

import "./Main.vue?vue&type=style&index=0&id=43baa6b4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1917936756/src/quotation-sales/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43baa6b4"]])

export default __exports__